SupportGiftOrderPopupView = require('../gift_order_popup_view')
SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportEditGiftServiceActionView extends SupportServiceActionsBaseView
  id: 'gift_to_friend'

  initialize: (options) ->
    @options = options || {}
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @order = Groupon.Support.currentOrder
    @attributes = @options.userId

  render: ->
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      service_action_id : 'edit_gift',
      service_action : I18n.t("js.modules.support.edit_gift")
    @extendHash(hash)

  actionHandler: (event)->
    current_order = Groupon.Support.currentOrder

    url = "/users/#{ currentUser.id }/gift_cards"
    window.open(url);
    @popup = new SupportGiftOrderPopupView()

  events :
    "click #edit_gift" : "actionHandler"

module.exports = SupportEditGiftServiceActionView
